import { Component,Input } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController } from 'ionic-angular';
import { ImagePicker } from '@ionic-native/image-picker';
/**
 * Generated class for the ReserveModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-reserve-modal',
  templateUrl: 'reserve-modal.html',
})
export class ReserveModalPage {
  @Input() Serial: string; 
  @Input() Note: string; 
  @Input() Date: string; 
  @Input() FileName: string; 
  
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public viewCtrl:ViewController,private imagePicker: ImagePicker) {
  }
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad ReserveModalPage');
    this.Serial=this.navParams.get('Serial');
    this.Note=this.navParams.get('Note');
    this.Date=this.navParams.get('Date');
    this.FileName=this.navParams.get('FileName');
    
  }
  public closeModal(){
   // var item = { 'Serial' : this.Serial ,'Note' : this.Note };
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reserve-modal/reserve-modal.ts